import { css } from '@emotion/react';
import { theme } from '../../theme/theme';
import type { PanelCardTone } from './PanelCard';

export const panelCardStyle = (tone: PanelCardTone) => css`
  background: ${tone === 'danger' ? `${theme.color.danger}0D` : theme.color.surface};
  border: 1px solid ${tone === 'danger' ? `${theme.color.danger}4D` : theme.color.border};
  border-radius: ${theme.radius.md}px;
  overflow: hidden;
`;

export const panelHeaderStyle = (flush: boolean, collapsedNoBody = false) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.space.sm}px;
  padding: ${flush
    ? `${theme.space.sm}px ${theme.space.md}px`
    : `${theme.space.md}px ${theme.space.md}px ${collapsedNoBody ? theme.space.md : 0}px`};
  ${flush && !collapsedNoBody && `border-bottom: 1px solid ${theme.color.border};`}
`;

/* 접기 토글 = 제목 영역 버튼. 제목 클릭으로 펼치기/접기. */
export const collapseToggleStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  margin: -4px -6px; /* hover 배경이 제목보다 살짝 넉넉하게 */
  padding: 4px 6px;
  border: none;
  border-radius: ${theme.radius.md}px;
  background: none;
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-align: left;
  transition: background 0.12s ease;

  &:hover {
    background: ${theme.color.primarySoft};
  }
`;

/* 셰브런 — 원형 배경 안 카라트. 펼침 ▾, 접힘 ▸(회전). 크고 또렷하게. */
export const chevronStyle = (collapsed: boolean) => css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: ${theme.radius.pill}px;
  background: ${theme.color.primary}1A;
  color: ${theme.color.primary};
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  transition: transform 0.18s ease;
  transform: rotate(${collapsed ? -90 : 0}deg);
`;

export const panelTitleStyle = (tone: PanelCardTone) => css`
  margin: 0;
  font-size: ${theme.fontSize.lg}px;
  font-weight: 600;
  color: ${tone === 'danger' ? theme.color.danger : theme.color.text};
`;

export const panelBodyStyle = (flush: boolean, hasHeader: boolean) => css`
  padding: ${flush ? 0 : `${hasHeader ? theme.space.sm : theme.space.md}px ${theme.space.md}px ${theme.space.md}px`};
`;
